<template>
  <div>
    <div class="modal fade" id="myModalReject" role="dialog">
      <div class="modal-dialog modal-dialog-centered model-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title pl-4">External Agency's Remark</h5>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body text-center pb-0">
            <hr>
            <input
              type="text"
              placeholder="External Agency's Remark"
              class="form-control external-agency"
              v-model="externalAgencyRemark.value"
            >
          </div>
          <div class="col-12 modal-footer pb-4">
            <button
              type="button"
              class="btn bgc-btn-primary"
              data-dismiss="modal"
              @click="updateStatus()"
            >Proceed</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "@vue/composition-api";
export default {
  name: "RejectModal",
  props:["externalAgencyRemark"],
  setup(props, { emit }){
    let state = reactive({
      reject: '79',
    });
    function updateStatus(){
      emit('updateStatus', state.reject, props.externalAgencyRemark.value);
    }
    return {
      state,
      updateStatus
    }
  }
};
</script>
<style scoped>
h5 {
  font-weight: 600;
  color: #666666;
}
.modal-body {
  overflow-y: hidden;
  margin-top: -20px;
}
.external-agency {
  max-width: 438px;
}
.pre-insp {
  color: #666666;
}
.success {
  color: #666666;
  margin-top: -5px;
}
.modal-footer {
  border-top: 0 none;
}
</style>